/* Match each product photo panel to the photo's own background colour.
   Samples the four corners of the image (through a separate CORS request so the visible <img>
   is untouched). When sampling works, the panel takes that colour and the photo switches to
   "contain" so nothing is cropped. Hosts without CORS keep the edge-to-edge "cover" fallback. */
(function () {
  if (window.__osdtgPhotoBg) return;
  window.__osdtgPhotoBg = true;

  var SELECTOR = '.card-wrapper .card__inner img, .osdtg-rot-cat__media img';
  var cache = {};

  function sample(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = 24, h = 24;
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0, w, h);
          var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2]];
          var r = 0, g = 0, b = 0;
          pts.forEach(function (p) {
            var d = ctx.getImageData(p[0], p[1], 1, 1).data;
            r += d[0]; g += d[1]; b += d[2];
          });
          resolve('rgb(' + Math.round(r / 4) + ',' + Math.round(g / 4) + ',' + Math.round(b / 4) + ')');
        } catch (e) {
          resolve(null); // tainted canvas: host doesn't allow reading pixels
        }
      };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
    return cache[src];
  }

  function apply(img) {
    if (img.dataset.osdtgBg) return;
    img.dataset.osdtgBg = 'pending';
    var src = img.currentSrc || img.src;
    if (!src) return;
    sample(src).then(function (color) {
      img.dataset.osdtgBg = color ? 'matched' : 'none';
      if (!color) return;
      var panel = img.closest('.card__inner, .osdtg-rot-cat__media');
      if (!panel) return;
      panel.style.setProperty('background', color, 'important');
      panel.classList.add('osdtg-bg-matched');
    });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.complete && img.naturalWidth) apply(img);
      else img.addEventListener('load', function () { apply(img); }, { once: true });
    });
  }

  function start() {
    scan();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
